import { HttpErrorResponse } from '@angular/common/http';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as AppointmentActions from './appointment.actions';
import { PublicPersonDTO, TreatmentAssociationDTO, TreatmentDTO } from '@auto-generated/ap-platform/care-providers';

export const APPOINTMENT_FEATURE_KEY = 'appointment';

export interface State extends EntityState<{}> {
	detail: any;
	provider: PublicPersonDTO;
	patient: any;
	loading: boolean;
	mainTreatment: TreatmentDTO;
	currentTreatmentAssociation: TreatmentAssociationDTO;
	error?: HttpErrorResponse | null | { errorText: string, isCancellation: boolean }
}

export interface AppointmentPartialState {
	readonly [APPOINTMENT_FEATURE_KEY]: State;
}

export const appointmentAdapter: EntityAdapter<State> = createEntityAdapter<State>();

export const initialState: State = appointmentAdapter.getInitialState({
	detail: undefined,
	provider: undefined,
	patient: undefined,
	loading: false,
	mainTreatment: undefined,
	currentTreatmentAssociation: undefined,
	error: undefined
});

const appointmentReducer = createReducer(
	initialState,

	on(AppointmentActions.LoadPatient, state => ({...state, loading: true})),
	on(AppointmentActions.LoadPatientCompleted, (state, {payload}) => ({...state, patient: payload})),
	on(AppointmentActions.LoadPatientFailed, state => ({...state, loading: false})),

	on(AppointmentActions.LoadBookingProviderByToken, state => ({...state, loading: true})),
	on(AppointmentActions.LoadBookingProviderByTokenCompleted, (state, {payload}) => ({...state, provider: payload})),
	on(AppointmentActions.LoadBookingProviderByTokenFailed, state => ({...state, loading: false})),

	on(AppointmentActions.SetTokenError, (state, {payload}) => ({...state, error: payload})),

	on(AppointmentActions.SetMainTreatment, (state, {treatment}) => ({...state, mainTreatment: treatment})),
	on(AppointmentActions.SetCurrentTreatmentAssociation, (state, {association}) => ({...state, currentTreatmentAssociation: association})),

	on(AppointmentActions.Error, (state, {error}) => ({...state, error})),

	on(AppointmentActions.ClearState, () => ({...initialState}))
);

export function reducer(state: State | undefined, action: Action) {
	return appointmentReducer(state, action);
}
